import { useContext, useCallback } from 'react';
import { UserContext } from 'contexts/UserContext';

const usePermissions = () => {
    //73 "CNST_VER_VENCIMIENTO_CONCESIONARIO" -> "HUERTO"
    //360 "CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO" -> PESTAÑA HUERTO
    //74 "CNST_GESTION_COMERCIAL_CONCESIONARIO"-> PESTAÑA SUBASTA
    //378 "CNST_VER_METRICAS_HUERTO" -> ESTADISTICAS HUERTO
    //395 "CNST_ASIGNACION_VOLUMEN_VENDEDOR" -> JEFE DE VENTA/ASIGNACION DE CONTRATOS
    const {
        user: {
            data: { Permissions: permissionsList },
        },
    } = useContext(UserContext);
    const checkPermission = useCallback(
        permission => {
            if (permissionsList) {
                for (let i = 0; i < permissionsList.length; i++) {
                    if (Array.isArray(permission)) {
                        if (
                            permission.includes(
                                permissionsList[i].NombreConstante
                            )
                        )
                            return true;
                    } else {
                        if (permissionsList[i].NombreConstante === permission)
                            return true;
                    }
                }
            }
            return false;
        },
        [permissionsList]
    );

    return { checkPermission, permissionsList };
};

export default usePermissions;
